import React from "react"
import ImpiantiTable from "./impiantiTable"
import impiantiStore from "../ImpiantiClienteStore"
import { ImpiantoWidget } from "./impiantoWidget";
import { ImpiantoClimaWidget } from "../../impiantiClima/components/impiantoClimaWidget";
import { NewImpiantoWidget } from "./newImpiantoWidget";
import { groupBy, map } from "lodash";
import { ImpiantoLight } from "../../generated";

export const ImpiantiClienteTable = (props: { idCliente: number, style?: React.CSSProperties }) => {
    const impianti = impiantiStore.useForCustomer(props.idCliente);
    if (impianti == null) return null;
    return <ImpiantiTable data={impianti} idCliente={props.idCliente} style={props.style} />
}

export const ImpiantiClienteWidgets = (props: { idCliente: number }) => {
    const impianti = impiantiStore.useForCustomer(props.idCliente);
    if (impianti == null) return null;
    const byGroup = map(groupBy(impianti, x => x.groupKey), (group, key) => ({ group, key: key == "null" ? null : key }));
    const noGroup = byGroup.filter(x => x.group.length == 1 || !x.key);
    const withGroup = byGroup.filter(x => x.key && x.group.length > 1)
    return <div className="d-flex flex-wrap align-items-center">
        {noGroup.length > 0 && <WithoutGroupWidgets impianti={noGroup.flatMap(i => i.group)} />}
        {withGroup.length > 0 && withGroup.map(x => <GroupedWidgets impianti={x.group} key={x.key} />)}
        <NewImpiantoWidget
            idCliente={props.idCliente}
        />
    </div>
}


const ImpiantoWidgetProvider = (props: { impianto: ImpiantoLight, inGroup?: boolean }) => {
    return props.impianto.type < 100
        ? <ImpiantoWidget
            key={props.impianto.id}
            impiantoData={props.impianto}
        />
        : <ImpiantoClimaWidget
            key={props.impianto.id}
            impiantoData={props.impianto}
            inGroup={props.inGroup}
        />
}

const WithoutGroupWidgets = (props: { impianti: ImpiantoLight[] }) => {
    return <div className="d-flex flex-wrap align-items-center" style={{ gap: 15 }}>
        {props.impianti.map(i => <ImpiantoWidgetProvider impianto={i} key={i.id} />)}
    </div>
}


const GroupedWidgets = (props: { impianti: ImpiantoLight[] }) => {
    return <div className="d-flex flex-column align-items-center m-2 border border-2 rounded">
        {props.impianti.map(i => <ImpiantoWidgetProvider impianto={i} key={i.id} inGroup />)}
    </div>
}   
